import * as React from 'react';

import {CloseButton} from 'shells/button/close-button/close-button';
import {RowIcon} from 'shells/row/row-icon';
import type {Option} from 'shells/select-picker-generic/types';

import {GraphQLSelectCompetitors} from '../../../../core/select/graphql-select-competitors';

import styles from '../../sidebar.module.css';

type Props = {
    onSelect: (competitor: Option) => void;
    onCreate: (arg1: string) => void;
    onCancel: () => void;
};

export function CompetitorsRowCreateForm(props: Props) {
    return (
        <div className='flex gap-8 flex-dir-row px-12 py-8 border-box'>
            <div className={styles['select-create-form-row-icon']}>
                <RowIcon type='competitors' />
            </div>
            <div className='flex gap-4 justify-sb full-width'>
                <div className='full-width'>
                    <GraphQLSelectCompetitors
                        selectedId={null}
                        onChange={props.onSelect}
                        onCreateOption={props.onCreate}
                        isCreateable={true}
                        hideDivider={true}
                        placeholder='Add a competitor…'
                    />
                </div>
                <CloseButton variant='dark' onClick={props.onCancel} size={10} />
            </div>
        </div>
    );
}
